import React, { useState } from 'react';
import { TabPanel, TabView } from 'primereact/tabview';
import { HcDashboard } from '../../features/correctiveActions/hcDashboard/HcDashboard';
import { Country } from '../../features/correctiveActions/type';

export const HcApprovers = () => {
    const [activeIndex, setActiveIndex] = useState<number>(0);
    const [selectedCountry, setSelectedCountry] = useState<Country>({'country_id':0,'country_name':''});
    const [isHCEdit, setIsHCEdit] = useState<boolean>(false);
    const [isHCConfig, setIsHCConfig] = useState<boolean>(false);
    const [editedJobCodes, setEditedJobCodes] = useState<string[]>([]);
    
    const resetState = () => {
        setIsHCEdit(false);
        setIsHCConfig(false);
        setSelectedCountry({'country_id':0,'country_name':''});
    }

    return (
        <div>
            
            <div className="card shadow bg-body rounded mt-4 border-0">
                <div className="card-body">
                    <div className="row">
                        <div className="col-md-12">
                            <TabView
                                activeIndex={activeIndex}
                                onTabChange={(e) => {
                                    if (e.index === 0) {
                                        resetState();
                                    }

                                    setActiveIndex(e.index);
                                }}
                            >
                                <TabPanel header="Dashboard">
                                    <HcDashboard
                                        selectedCountry={selectedCountry}
                                        isHCEdit={isHCEdit}
                                        isHCConfig={isHCConfig}
                                        setSelectedCountry={setSelectedCountry}
                                        setActiveIndex={setActiveIndex}
                                        setIsHCEdit={setIsHCEdit}
                                        setIsHCConfig={setIsHCConfig}
                                        setEditedJobCodes={setEditedJobCodes}
                                     />
                                </TabPanel>
                                {activeIndex === 1 ? <TabPanel header="HC Approvers">
                                    {/* HC approver tab goes here ! */}
                                    <HcDashboard
                                        selectedCountry={selectedCountry}
                                        isHCEdit={isHCEdit}
                                        isHCConfig={isHCConfig}
                                        editedJobCodes={editedJobCodes}
                                        setSelectedCountry={setSelectedCountry}
                                        setActiveIndex={setActiveIndex}
                                        setIsHCEdit={setIsHCEdit}
                                        setIsHCConfig={setIsHCConfig}
                                        setEditedJobCodes={setEditedJobCodes}
                                    />
                                </TabPanel>
                                    :
                                    ''}
                            </TabView>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
